import {useMutation} from "@tanstack/react-query";
import type {AxiosError} from "axios";

import {errorHandler} from "@/src/modules/core/lib";

import {isShiftGateBusinessError} from "../lib/shift-gate-errors";
import {officerService} from "../services";
import {ExtendShiftRequest} from "../types";

export function useExtendShift() {
  return useMutation({
    mutationFn: (data: ExtendShiftRequest) => officerService.extendShift(data),
    onError: (error) => {
      if (isShiftGateBusinessError(error)) return;
      errorHandler(error as AxiosError);
    },
  });
}
